export default "__VITE_ASSET__CTg1ElDh__"